import axios from "@/helpers/base";

export default Authorization => {
  return new Promise((resolve, reject) => {
    axios
      .get("/auth/me", {
        headers: {
          Authorization
        }
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};
